var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGenderSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    width: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#003A5C",
    d: "M24 31q3.3 0 5.65-2.35Q32 26.3 32 23q0-3.3-2.35-5.65Q27.3 15 24 15q-3.3 0-5.65 2.35Q16 19.7 16 23q0 3.3 2.35 5.65Q20.7 31 24 31Zm-1.5 15v-4h-4v-3h4v-5.05q-4.1-.7-6.8-3.775T13 23q0-1.8.55-3.5t1.65-3.15l-2.1-2.1-2.8 2.8-2.1-2.1 2.8-2.8-5-5V13H3V2h11v3H8.15l5 5 2.8-2.8 2.1 2.1-2.8 2.8 2.15 2.15q1.45-1.1 3.125-1.675T24 12q1.8 0 3.5.55t3.15 1.65l9.2-9.2H34V2h11v11h-3V7.15l-9.2 9.2q1.1 1.45 1.65 3.15.55 1.7.55 3.5 0 4.1-2.7 7.175t-6.8 3.775V39h4v3h-4v4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenderSymbol);
export default __webpack_public_path__ + "static/media/gender_symbol.1e9cb1178daef0e236282da1a3cff576.svg";
export { ForwardRef as ReactComponent };